import { render } from "./index.vue?vue&type=template&id=d2d1fd84&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=d2d1fd84&scoped=true&lang=css"

import exportComponent from "/Users/xingheng/code/front-end/v3-draggable-resizable/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d1fd84"]])

export default __exports__